import cn from 'classnames/bind';
import React, { FunctionComponent } from 'react';

import { LinkProps } from './Link.types';
import styles from './Link.module.css';

const cx = cn.bind(styles);

export const Link: FunctionComponent<LinkProps> = (props) => {
    const { children, className, innerRef, ...rest } = props;

    const classList = cx('root', className);

    return (
        <a
            className={classList}
            ref={innerRef}
            {...rest} // eslint-disable-line react/jsx-props-no-spreading
        >
            {children}
        </a>
    );
};
